import { render, staticRenderFns } from "./NotesPanel.vue?vue&type=template&id=0d52cd28"
import script from "./NotesPanel.vue?vue&type=script&lang=ts"
export * from "./NotesPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports